import { useCallback } from 'react';

import { useBrowserAudioSetting } from '@/hooks/useBrowserAudioSetting';
import { VAD_THRESHOLD_TYPE } from '@/states/slices/browserAudioSettingSlice';

/**
 * オーディオ設定ダイアログ用 hooks
 *
 * @returns
 */
export const useSettingAudioDialog = () => {
  const { isProfanityFilter, setVadThreshold, setIsProfanityFilter } =
    useBrowserAudioSetting();

  /**
   * 弱いボタンクリック
   */
  const clickMediumButton = useCallback(() => {
    setVadThreshold(VAD_THRESHOLD_TYPE.MEDIUM);
  }, [setVadThreshold]);

  /**
   * 強いボタンクリック
   */
  const clickHighButton = useCallback(() => {
    setVadThreshold(VAD_THRESHOLD_TYPE.HIGH);
  }, [setVadThreshold]);

  /**
   * 冒涜フィルタトグルON/OFFの処理
   */
  const onChangeIsProfanityFilter = useCallback(
    (value: boolean) => {
      setIsProfanityFilter(value);
    },
    [setIsProfanityFilter],
  );

  return {
    // 冒涜フィルタ(ON/OFF)
    isProfanityFilter,
    // 弱いボタンクリック
    clickMediumButton,
    // 強いボタンクリック
    clickHighButton,
    // 冒涜フィルタトグルON/OFFの処理
    onChangeIsProfanityFilter,
  };
};
